import { RouterModule, Routes } from '@angular/router';
import { AppComponent } from './app.component';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { MediaComponent } from './media/media.component';
import { SearchComponent } from "app/search/search.component";
import { MemberComponent } from "app/member/member.component";
import { LoginComponent } from "app/login/login.component";
import { AuthGuard } from "app/webservice/authguard.service";
import { MediaSearchComponent } from "app/media-search/media-search.component";
import { MemberAddComponent } from "app/member-add/member-add.component";
import { MediaAddComponent } from "app/media-add/media-add.component";
import { HistoryComponent } from "app/history/history.component";
import { SpineLabelComponent } from './spine-label/spine-label.component';
import { PrintSpineLabelComponent } from './print-spine-label/print-spine-label.component';
import { OverdueReportComponent } from './overdue-report//overdue-report.component';
import { SetupComponent } from "app/setup/setup.component";
import { PrintBarcodeComponent } from 'app/print-barcode/print-barcode.component';

const routes: Routes = [
  { path: 'media/add', component: MediaAddComponent, canActivate: [AuthGuard] },
  { path: 'media/search', component: MediaSearchComponent, canActivate: [AuthGuard] },
  { path: 'media/:Oid', component: MediaComponent, canActivate: [AuthGuard] },
  { path: 'member/search', component: SearchComponent, canActivate: [AuthGuard] },
  { path: 'member/add', component: MemberAddComponent, canActivate: [AuthGuard] },
  { path: 'member/:Oid', component: MemberComponent, canActivate: [AuthGuard] },
  { path: 'login', component: LoginComponent },
  { path: 'history', component: HistoryComponent, canActivate: [AuthGuard]},
  { path: 'spinelabel', component: SpineLabelComponent, canActivate: [AuthGuard]},
  { path: 'printspinelabels', component: PrintSpineLabelComponent, canActivate: [AuthGuard]},
  { path: 'setup', component: SetupComponent, canActivate: [AuthGuard] },
  { path: 'printbarcode', component: PrintBarcodeComponent, canActivate: [AuthGuard] },
  { path: 'overduereport', component: OverdueReportComponent, canActivate: [AuthGuard] },
  { path: '', component: MediaSearchComponent },
  { path: '**', component: LoginComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: []
})
export class AppRoutingModule { }

export const appRoutingProviders: any[] = [];

export const routing: ModuleWithProviders = RouterModule.forRoot(routes);


// WEBPACK FOOTER //
// c:/Projects/CCLibrary/Client/src/app/app.router.ts